module.exports = __webpack_public_path__ + "img/17-gesture.6eddedc8.jpg";